import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { API_RATE_LIMIT_MESSAGE, extractHttpErrorMessage, isRateLimitHttpStatus } from '../utils/http-error.util';

/**
 * Surfaces HTTP 429 responses with a single toast. Does not retry or swallow the error.
 */
export const rateLimitInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && isRateLimitHttpStatus(err.status)) {
        const msg = extractHttpErrorMessage(err, API_RATE_LIMIT_MESSAGE);
        toast.warn(msg);
      }
      return throwError(() => err);
    }),
  );
};
